import { Component, OnInit } from '@angular/core';
import { DeleteModalComponent } from '@components/delete-modal/delete-modal.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { sortTable } from 'src/app/helpers/sort-table';
import { DoctorsService } from 'src/app/_services/doctors.service';
import { baseUrl, environment } from 'src/environments/environment';

@Component({
  selector: 'app-featured-doctors-list',
  templateUrl: './featured-doctors-list.component.html',
  styleUrls: ['./featured-doctors-list.component.scss'],
})
export class FeaturedDoctorsListComponent implements OnInit {
  pageTitle: string = 'Featured Doctors';
  doctorsArray = [];
  filteredDoctorsArray = [];
  theadArray = [
    'EN Name',
    'AR Name',
    'EN Title',
    'AR Title',
    'Rank',
    'Actions',
  ];

  modalRef: BsModalRef;
  invertSort: boolean = false;

  constructor(
    private _DoctorsService: DoctorsService,
    public toastr: ToastrService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.getAllFeaturedDoctors();
  }

  getAllFeaturedDoctors() {
    this._DoctorsService.getAllFeaturedDoctors().subscribe((res) => {
      res?.data?.featuredDoctors.map((doctor) => {
        doctor.imagePath = `${doctor.imagePath}`;
        this.doctorsArray.push(doctor);
        this.filteredDoctorsArray = [...this.doctorsArray];
      });
    });
  }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredDoctorsArray = sortTable(
      this.filteredDoctorsArray,
      'fullName',
      this.invertSort
    );
  }

  onDeleteDoctor(event, item): void {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-danger',
      initialState: {
        itemId: item.id,
        itemName: item.fullName,
      },
    };

    this.modalRef = this.modalService.show(DeleteModalComponent, initialState);

    this.modalRef.content.event.subscribe((data) => {
      this.onDeleteDoctorSubmit(item.fullName, data);
    });
  }

  onDeleteDoctorSubmit(doctorName, doctorId) {
    this._DoctorsService
      .deleteFeatureDoctor({ id: doctorId })
      .subscribe((res) => {
        showNotification(
          'success',
          `${doctorName} has been deleted`,
          this.toastr
        );

        this.doctorsArray = this.doctorsArray.filter(
          (doctor) => doctor.id !== doctorId
        );

        this.filteredDoctorsArray = [...this.doctorsArray];

        this.modalRef.hide();
      });
  }
}
